import * as React from "react";
import * as styles from "./styles.css";
import Heading from "backpack-ui/dist/components/heading";
import ShareSettings from "backpack-ui/dist/components/shareMenu/shareSettings";
import SocialIconButton from "backpack-ui/dist/components/socialIconButton";
var SocialShare = function (_a) {
    var description = _a.description, headingText = _a.headingText, image = _a.image, style = _a.style, text = _a.text, twitterContent = _a.twitterContent, url = _a.url;
    return (React.createElement("div", { className: "socialShareContainer" },
        headingText &&
            React.createElement(Heading, { size: "tiny", weight: "thick", level: 5, caps: true }, headingText),
        React.createElement("div", { className: headingText ? styles.containerWithHeading : "" },
            React.createElement(ShareSettings, { shareContent: {
                    description: description,
                    image: image,
                    text: text,
                    twitterContent: twitterContent,
                    url: url,
                    via: "lonelyplanet",
                } }, function (shareActions, shareUrls) { return (React.createElement("div", null,
                React.createElement(SocialIconButton, { network: "twitter", href: shareUrls.twitter, onClick: function (event) {
                        shareActions.twitter();
                        event.preventDefault();
                    }, className: styles.button }),
                React.createElement(SocialIconButton, { network: "facebook", href: shareUrls.facebook, onClick: function (event) {
                        shareActions.facebook();
                        event.preventDefault();
                    }, className: styles.button }),
                React.createElement(SocialIconButton, { network: "pinterest", href: shareUrls.pinterest, onClick: function (event) {
                        shareActions.pinterest();
                        event.preventDefault();
                    }, className: styles.button }),
                React.createElement(SocialIconButton, { network: "whatsapp", href: shareUrls.whatsapp, onClick: function (event) {
                        shareActions.whatsapp();
                        event.preventDefault();
                    }, className: styles.button }))); }))));
};
export default SocialShare;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/socialShare/index.tsx
// module id = 4xHA
// module chunks = 3